import { SNACKBAR_VARIANTS } from '../Snackbar.consts'
import { useRef } from 'react'
import { useSnackbar } from 'notistack'
import SlideTransition from '../../Transitions/SlideTransition'
import { translateManager as t } from '../../../services/TranslateManager'

export const OUT_OF_STOCK_PROPERTY = {
  FRAME: 'Frame',
  SIZE: 'Size',
  MATERIAL: 'Material',
}

export const OUT_OF_STOCK_NOTIFICATION_TYPE = {
  NOT_AVAILABLE: 'Not Available',
  IN_OTHER_MATERIALS: 'In Other Materials',
  IN_OTHER_SIZES: 'In Other Sizes',
}

export function useOutOfStockNotification() {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar()
  const isReplaced = useRef(false)

  const notifyOutOfStock = ({
    name,
    title,
    subtitle,
    showUndo,
    undoCallback,
    type,
    missingMaterial,
    missingSize,
    missingFrame,
    previousMaterial,
    previousSize,
    previousFrame,
  }) => {
    // Indicate that the current snackbar is being replaced
    isReplaced.current = true

    // Close the current snackbar
    closeSnackbar()

    // Reset the isReplaced flag after a small delay to allow the closing animation to complete
    setTimeout(() => {
      isReplaced.current = false
    }, 0)

    enqueueSnackbar('', {
      TransitionComponent: (props) => (
        <SlideTransition {...props} isReplaced={isReplaced} />
      ),
      variant: SNACKBAR_VARIANTS.COMMON,
      name: `Out of Stock - ${name}`,
      title,
      subtitle,
      showArrow: true,
      action: showUndo && t.get('out_of_stock.undo'),
      actionCallback: undoCallback,
      analyticsProperties: {
        Type: type,
        'Missing Material': missingMaterial,
        'Missing Size': missingSize,
        'Missing Frame': missingFrame,
        'Can Undo': showUndo,
        'Previous Material': previousMaterial,
        'Previous Size': previousSize,
        'Previous Frame': previousFrame,
        Text: subtitle ? `${title}; ${subtitle}` : title,
        'Is Disabled': !showUndo,
      },
    })
  }

  return { notifyOutOfStock }
}
